import { addSeconds, areIntervalsOverlapping, compareAsc, isBefore } from '@/helpers/date'

import { Period } from './Period'

// It is technically possible to have a period with a start date that is after the end date.
// This should of course not happen but it is possible. This function is to prevent areIntervalsOverlapping from throwing an error.
const sanitizePeriod = (period: Period): Period => {
    if (isBefore(period.end, period.start)) {
        return {
            start: period.end,
            end: period.start,
        }
    }

    return period
}

export const doesDateOverlapWithPeriod = (date: Date, period: Period): boolean => {
    const sanitizedPeriod = sanitizePeriod(period)

    return (
        areIntervalsOverlapping(
            {
                start: date,
                end: addSeconds(date, 1),
            },
            {
                start: sanitizedPeriod.start,
                end: sanitizedPeriod.end,
            },
        )
    )
}

export const arePeriodsDeviated = (period1: Period, period2: Period): boolean => (compareAsc(period1.start, period2.start) !== 0
    || compareAsc(period1.end, period2.end) !== 0)
